import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import Background from "../Background/Background";

export default function FullScreenLoader({ showLoader }) {
  const [open, setOpen] = React.useState(showLoader);

  React.useEffect(() => {
    setOpen(showLoader);
  }, [showLoader]);
  return (
    <Background>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Background>
  );
}
